const LOTO_TYPE_LABELS = {
  MB_2: 'Loto 2 số',
  MB_3: 'Loto 3 số',
  MB_5: 'Loto 5 số',
  MB_BAO2: 'Bao loto 2 số',
  D: 'Đầu 2 số',
  C: 'Cuối 2 số',
  DC: 'Đầu/Cuối 2 số',
  DAU2: 'Đầu 2 số',
  CUOI2: 'Cuối 2 số',
  DAU_CUOI2: 'Đầu/Cuối 2 số',
  DAU3: 'Đầu 3 số',
  CUOI3: 'Cuối 3 số',
  DAU_CUOI3: 'Đầu/Cuối 3 số',
  LO18: 'Lô 18',
  L18: 'Lô 18',
  L17: '17 lô',
  L4: '4 lô',
  L16: '16 lô',
  L7: '7 lô',
  L5: 'Loto 5 số',
  BAO2: 'Bao loto 2 số',
  THUDO_2: 'Lô tô 2 số',
  THUDO_BAO2: 'Bao lô tô 2 số',
  THUDO_3: 'Lô tô 3 số',
  THUDO_5: 'Lô tô 5 số',
}

const BAO_FILTER_LABELS = {
  chan: 'Chẵn',
  le: 'Lẻ',
  lon: 'Lớn',
  nho: 'Nhỏ',
  'tong-chan': 'Tổng chẵn',
  'tong-le': 'Tổng lẻ',
  dau: 'Đầu',
  duoi: 'Đuôi',
}

export const getLotoTypeLabel = (lotoType) => {
  if (!lotoType) return ''

  return LOTO_TYPE_LABELS[lotoType] || lotoType
}

export const getBaoFilterLabel = (baoFilter, baoDigits) => {
  const label = BAO_FILTER_LABELS[baoFilter]
  if (!label) return ''

  const digits = Array.isArray(baoDigits) ? baoDigits : []
  if (['dau', 'duoi'].includes(baoFilter) && digits.length) {
    return `${label} ${digits.join(',')}`
  }
  return label
}

export const getLotoTypeLabelWithFilter = (lotoType, baoFilter, baoDigits) => {
  const base = getLotoTypeLabel(lotoType)
  const filterLabel = getBaoFilterLabel(baoFilter, baoDigits)
  if (!filterLabel) return base
  return `${base} - ${filterLabel}`
}

export const getLotoRewardLabel = (rewardId) => {
  if (!rewardId) return ''

  const parts = String(rewardId).split('-')
  const lotoType = parts.length >= 3 ? parts[1] : rewardId

  return getLotoTypeLabel(lotoType)
}
